export default "__VITE_ASSET__CXR_Nnn0__"